import { ApiClientInstance } from '@shared/api';

import { TAppVersionItem } from './types';

export const getAppUpdateStatus = (currentVersion?: string) => {
  return ApiClientInstance.get<TAppVersionItem[]>('v2/home/appsettings/versions', {
    queryParams: { version: currentVersion },
  });
};
